namespace $.$$ {
	
	$mol_style_define( $hyoo_tree_edit, {
		
		List: {
			margin: {
				left: $mol_gap.block,
			},
			border: {
				radius: $mol_gap.round,
			},
			background: {
				color: $mol_theme.card,
			},
		},
		
		// Item_type: {
		// 	flex: {
		// 		basis: `10rem`,
		// 		shrink: 0,
		// 	},
		// },
		
		// Item_value: {
		// 	flex: {
		// 		basis: `30rem`,
		// 		grow: 0,
		// 	},
		// },
		
	} )
	
}
